import HomePage from '@/components/HomePage';
import DashboardPage from '@/components/DashboardPage';
import LeaderboardPage from '@/components/LeaderboardPage';
import DonatePage from '@/components/DonatePage';
import PrizePoolsPage from '@/components/PrizePoolsPage';
import StatsPage from '@/components/StatsPage';
import PrivacyPage from '@/components/PrivacyPage';
import LicensePage from '@/components/LicensePage';
import CopyrightPage from '@/components/CopyrightPage';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/hooks/use-theme';
// import { OAuthProvider } from '@/contexts/OAuthContext';
import { JSX } from 'react';
import { Route, Routes } from 'react-router-dom';

function App(): JSX.Element {
  return (
    <ThemeProvider>
      {/* NOTE: UI Generator - Uncomment OAuthProvider wrapper below if OAuth functionality is needed.
          See .claude/skills/oauth/docs/implementation-guide.md for OAuth implementation guide. */}
      {/* <OAuthProvider> */}
      <div
        id='app-container'
        className='relative min-h-screen flex flex-col bg-background'
      >
        <main id='app-main' className='flex-1'>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/dashboard' element={<DashboardPage />} />
            <Route path='/leaderboard' element={<LeaderboardPage />} />
            <Route path='/donate' element={<DonatePage />} />
            <Route path='/prize-pools' element={<PrizePoolsPage />} />
            <Route path='/stats' element={<StatsPage />} />
            <Route path='/privacy' element={<PrivacyPage />} />
            <Route path='/license' element={<LicensePage />} />
            <Route path='/copyright' element={<CopyrightPage />} />
          </Routes>
        </main>

        <Toaster />
      </div>
      {/* </OAuthProvider> */}
    </ThemeProvider>
  );
}

export default App;
